import { useStores } from "@stores/hooks/useStores.ts";

export const usePatientLabel = (capitalizeFirst: boolean = false) => {
  const { userExperience } = useStores();

  return userExperience.localisedConfig("patientDisplay", {
    capitalizeFirst
  });
};
